import type { Card } from '@tv-casino/shared';
import { SUIT_NAMES, SUIT_PIP_BOX, SUIT_PIP_PATHS } from '@tv-casino/shared';

/** A suit pip sized to 1em and painted in the current text colour. The pips are
    geometry (`SUIT_PIP_PATHS`), not the ♠♥♦♣ glyphs — the same design the
    native shells draw, so one deck prints the same suits on every screen. */
export function SuitIcon({ suit, className }: { suit: Card['suit']; className?: string }) {
  return (
    <svg
      className={className}
      viewBox={`0 0 ${SUIT_PIP_BOX} ${SUIT_PIP_BOX}`}
      width="1em"
      height="1em"
      fill="currentColor"
      role="img"
      aria-label={SUIT_NAMES[suit]}
    >
      <path d={SUIT_PIP_PATHS[suit]} />
    </svg>
  );
}
